<template>
  <div class="dress">
    <v-card>
      <v-card-title> Crear Venta </v-card-title>
      <v-card-text>
        <v-stepper v-model="stepper">
          <v-stepper-header>
            <v-stepper-step :complete="stepper > 1" step="1">
              Cliente
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 2" step="2">
              Venta
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 3" step="3">
              Vestidos
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4"> Pagos </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-progress-linear
                value="15"
                indeterminate
                absolute
                top
                v-if="this.$store.state.client.isLoading"
              ></v-progress-linear>
              <v-form ref="formClient" v-model="formClient">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.colombian_id"
                        :rules="[rules.required]"
                        label="Identificación"
                        required
                        @change="getClient"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.first_name"
                        :rules="[rules.required]"
                        label="Nombres"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.last_name"
                        :rules="[rules.required]"
                        label="Apellidos"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.phone"
                        :rules="[rules.required]"
                        label="Teléfono"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.email"
                        label="Correo"
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="modelCLient.address"
                        :rules="[rules.required]"
                        label="Dirección"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>

              <v-btn color="primary" @click="saveClient"> Continuar </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="formSale" v-model="formSale">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-select
                        :items="employees"
                        item-text="full_name"
                        item-value="id"
                        label="Seleccione Asesor"
                        no-data-text="No hay registros..."
                        :rules="[rules.required]"
                        v-model="model.employee_id"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="3" v-if="multilanguage">
                      <v-select
                        :items="idioms"
                        v-model="model.lan"
                        :rules="[rules.required]"
                        label="Idioma"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>

              <v-btn color="primary" @click="nextStepDress"> Continuar </v-btn>
              <v-btn text @click="stepper = 1"> Volver </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-container>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-toolbar>
                      <v-toolbar-title>Lista de vestidos</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2"
                        small
                        fab
                        dark
                        color="indigo"
                        @click="dialogAddDress = true"
                      >
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                    </v-toolbar>
                  </v-col>
                </v-row>
                <v-row v-for="(dress, index) in model.dresses" :key="index">
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        <v-avatar
                          color="primary"
                          size="25"
                          class="white--text mr-3"
                          >{{ index + 1 }}</v-avatar
                        >
                        {{ dress.dress.code }} - {{ dress.dress.color }} -
                        {{ dress.sale_value | formatNumber }}
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="green"
                              v-bind="attrs"
                              v-on="on"
                              @click="editDress(dress)"
                            >
                              <v-icon dark> mdi-circle-edit-outline </v-icon>
                            </v-btn>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              color="red"
                              v-bind="attrs"
                              v-on="on"
                              @click="deleteDress(dress)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="model.dresses.length == 0">
                  <v-col cols="12">
                    <v-card>
                      <v-card-title class="d-inline-block">
                        No hay registros agregados...
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>

              <v-btn color="primary" @click="nextStepPayment">
                Continuar
              </v-btn>
              <v-btn
                text
                @click="multilanguage ? (stepper = 2) : (stepper = 1)"
              >
                Volver
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-data-table
                :headers="headersPayment"
                :items="model.payments"
                class="elevation-1 mb-7"
                no-data-text="No hay registros agregados..."
                hide-default-footer
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Pagos</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <span class="text-h6 font-weight-bold">
                      Total a pagar: {{ model.sale_value | formatNumber }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialogAddPayment" max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          Agregar
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline"
                            >{{ titleDialogPayment }} Pago</span
                          >
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-form ref="formPayment" v-model="formAddPayment">
                            <v-container>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="modelPayment.value"
                                    label="Valor"
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-select
                                    v-model="modelPayment.payment_method"
                                    label="Metodo de pago"
                                    :rules="[rules.required]"
                                    :items="paymentMethods"
                                  ></v-select>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closePayment"
                          >
                            Cancelar
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="savePayment"
                          >
                            {{ titleDialogPayment }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDeletePayment" max-width="500px">
                      <v-card>
                        <v-card-title class="headline"
                          >Seguro que desea eliminar este pago?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closeDeletePayment"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deletePaymentConfirm"
                            >Aceptar</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.actions`]="item">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="green"
                        v-bind="attrs"
                        v-on="on"
                        @click="editPayment(item.item)"
                      >
                        <v-icon dark> mdi-circle-edit-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="deletePayment(item.item)"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <v-btn color="primary" @click="saveSale"> Guardar </v-btn>
              <v-btn text @click="stepper = 3"> Volver </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>

    <!-- Dialog add dress -->
    <v-dialog v-model="dialogAddDress" persistent width="600">
      <v-card>
        <v-card-title>{{ titleDialogDress }} Vestido</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <v-form ref="formAddDress" v-model="formAddDress">
            <v-select
              :items="categories"
              item-value="id"
              label="Seleccione categoría"
              item-text="name"
              no-data-text="No se encontraron resultados"
              v-model="modelAddDress.category"
              @change="getDressesByCategory"
              :rules="[rules.required]"
            >
            </v-select>

            <v-autocomplete
              :items="dresses"
              item-value="id"
              label="Seleccione el vestido"
              :item-text="(item) => `${item.code} - ${item.color}`"
              no-data-text="No se encontraron resultados"
              v-model="modelAddDress.dress"
              :rules="[rules.required]"
            >
            </v-autocomplete>

            <v-text-field
              v-model="modelAddDress.sale_value"
              :rules="[rules.required]"
              label="Valor de venta"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="blue darken-1" @click="closeDialogDress">
            Cancelar
          </v-btn>
          <v-btn text color="blue darken-1" @click="saveDress">
            {{ titleDialogDress }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog delete dress -->
    <v-dialog v-model="dialogDeleteDress" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Seguro que desea eliminar este vestido?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteDress"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteDressConfirm"
            >Aceptar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog loader -->
    <v-dialog
      v-model="this.$store.state.sale.create.isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Por favor espere...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog confirmation  -->
    <v-dialog v-model="confirmDialog.active" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">{{
          confirmDialog.message
        }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="confirmDialog.active = false"
            >Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="processConfirmDialog"
            >Aceptar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_CLIENT } from "@/store/client";
import { SET_CATEGORIES } from "@/store/categories";
import { SET_EMPLOYEES } from "@/store/employee";
import { SET_DRESSES } from "@/store/dresses";
import { SET_ALERT } from "@/store/alert";
import { SET_USER } from "@/store/user";
import { SET_SALE } from "@/store/sale";
import { mapGetters } from "vuex";
export default {
  name: "Create",
  props: ["id"],
  filters: {
    formatNumber(value) {
      if (typeof value === "string") {
        value = value.split(".").join("");
      }
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
      }).format(value);
    },
  },
  data: () => ({
    currentClient: null,
    currentDress: null,
    currentPayment: null,
    formClient: true,
    formSale: true,
    formAddDress: true,
    formAddPayment: true,
    stepper: 1,
    menuSaleDate: null,
    menuEventDate: null,
    dialogAddDress: false,
    dialogAddPayment: false,
    dialogDeleteDress: false,
    dialogDeletePayment: false,
    confirmDialog: {
      active: false,
      message: "",
      callFunction: "",
      item: null,
    },
    model: {
      client_id: "",
      sale_value: "",
      initial_value: "",
      lan: "es",
      employee_id: "",
      dresses: [],
      payments: [],
    },
    modelCLient: {
      first_name: "",
      last_name: "",
      colombian_id: "",
      phone: "",
      email: "",
      address: "",
    },
    modelAddDress: {
      category: null,
      dress: null,
      sale_value: "",
    },
    modelPayment: {
      value: "",
      payment_method: "",
    },
    colombian_id: "",
    rules: {
      required: (value) => !!value || "Campo obligatorio.",
    },
    sale: null,
    categories: [],
    dresses: [],
    employees: [],
    headersPayment: [
      { text: "Valor", value: "value", sortable: false },
      { text: "Método de pago", value: "paymentMethodLan", sortable: false },
      { text: "Acción", value: "actions", sortable: false },
    ],
    idioms: [
      { text: "Español", value: "es" },
      { text: "Ingles", value: "en" },
    ],
    editedIndex: -1,
    editedIndexDress: -1,
    editedIndexPayment: -1,
    multilanguage: 0,
  }),
  created() {
    this.$store.dispatch("getCategoriesAll");
    if (this.id) {
      this.$store.dispatch("getSale", this.id);
    }
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_CLIENT) {
        this.currentClient = state.client.client;
        this.model.client_id = this.currentClient.id;
        this.setClient();
      }
      if (mutation.type === SET_CATEGORIES) {
        this.categories = state.categories.categories;
      }
      if (mutation.type === SET_DRESSES) {
        this.dresses = state.dresses.dresses;
        if (this.sale) {
          this.sale.dresses.forEach((item) => {
            this.dresses.push(item);
          });
        }
      }
      if (mutation.type === SET_USER) {
        this.multilanguage = state.user.user.office.multilanguage;
        this.$store.dispatch(
          "getEmployeesAll",
          "office=" + state.user.user.office.id + "&position=ADVISER"
        );
      }
      if (mutation.type === SET_EMPLOYEES) {
        this.employees = state.employee.employees;
      }
      if (mutation.type === SET_SALE) {
        this.setSale(state.sale.sale);
      }
    });
  },
  mounted() {
    if (this.employees.length == 0) {
      this.$store.dispatch("getUser");
    }
  },
  computed: {
    ...mapGetters(["getStatusLan", "getStatusColor"]),
    saleValue() {
      return this.model.sale_value;
    },
    saleValueDress() {
      return this.modelAddDress.sale_value;
    },
    value() {
      return this.modelPayment.value;
    },
    titleDialogDress() {
      return this.currentDress ? "Editar" : "Agregar";
    },
    titleDialogPayment() {
      return this.currentPayment ? "Editar" : "Agregar";
    },
    paymentMethods() {
      return this.$store.state.payments.paymentMethods;
    },
  },
  watch: {
    saleValueDress(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.modelAddDress.sale_value = new Intl.NumberFormat("de-DE").format(
          val
        );
      }
    },
    value(val) {
      if (parseInt(val) > 0) {
        val = val.split(".").join("");
        this.modelPayment.value = new Intl.NumberFormat("de-DE").format(val);
      }
    },
  },
  methods: {
    async getClient() {
      this.currentClient = null;
      this.colombian_id = this.modelCLient.colombian_id;
      this.$store.dispatch("getClient", this.colombian_id);
      await this.$refs.formClient.reset();
      this.modelCLient.colombian_id = this.colombian_id;
    },
    setClient() {
      this.modelCLient = {
        first_name: this.currentClient.first_name,
        last_name: this.currentClient.last_name,
        colombian_id: this.currentClient.colombian_id,
        phone: this.currentClient.phone,
        email: this.currentClient.email,
        address: this.currentClient.address,
      };
    },
    async saveClient() {
      if (!this.$refs.formClient.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }

      if (!this.currentClient) {
        await this.$store.dispatch("createClient", this.modelCLient);
      } else {
        this.$store.dispatch("updateClient", {
          id: this.currentClient.id,
          form: this.modelCLient,
        });
      }

      this.stepper = 2;
    },
    nextStepDress() {
      if (!this.$refs.formSale.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      this.stepper = 3;
    },
    getDressesByCategory() {
      this.$store.dispatch("getDressesByCategory", this.modelAddDress.category);
    },
    editDress(item) {
      this.editedIndexDress = this.model.dresses.indexOf(item);
      this.currentDress = item;
      this.modelAddDress = {
        category: item.category,
        dress: item.id,
        sale_value: item.sale_value,
      };
      if (this.sale) {
        this.modelAddDress.sale_dress_id = item.sale_dress_id;
      }
      this.getDressesByCategory();
      this.dialogAddDress = true;
    },
    deleteDress(item) {
      this.editedIndexDress = this.model.dresses.indexOf(item);
      if (this.sale) {
        this.activateConfirmDialog(
          "deleteDressConfirm",
          item,
          `Seguro que desea eliminar el vestido ${item.code} de esta venta?`
        );
        return;
      }
      this.dialogDeleteDress = true;
    },
    deleteDressConfirm() {
      if (this.sale) {
        this.$store.dispatch(
          "deleteSaleDress",
          this.confirmDialog.item.sale_dress_id
        );
      }
      this.model.dresses.splice(this.editedIndexDress, 1);
      this.closeDeleteDress();
    },
    closeDialogDress() {
      this.dialogAddDress = false;
      this.$nextTick(() => {
        this.currentDress = null;
        this.$refs.formAddDress.resetValidation();
        this.modelAddDress = {
          category: null,
          dress: null,
          sale_value: "",
        };
        this.editedIndexDress = -1;
      });
    },
    closeDeleteDress() {
      this.dialogDeleteDress = false;
      this.editedIndexDress = -1;
    },
    saveDress() {
      if (!this.$refs.formAddDress.validate()) {
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "error",
        });
        return;
      }
      var dress = this.dresses.find(
        (dress) => dress.id == this.modelAddDress.dress
      );
      const obj = {
        id: this.modelAddDress.dress,
        sale_value: this.modelAddDress.sale_value.split(".").join(""),
        category: this.modelAddDress.category,
        dress: dress,
      };
      if (this.currentDress) {
        Object.assign(this.model.dresses[this.editedIndexDress], obj);
        if (this.sale) {
          this.$store.dispatch("updateSaleDress", {
            id: this.modelAddDress.sale_dress_id,
            form: obj,
          });
        }
      } else {
        this.model.dresses.push(obj);
      }
      this.closeDialogDress();
    },
    async nextStepPayment() {
      if (this.model.dresses.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar mínimo un vestido",
          type: "error",
        });
        return;
      }
      await this.setNumber();      
      this.stepper = 4;
    },
    editPayment(item) {
      this.editedIndexPayment = this.model.payments.indexOf(item);
      this.currentPayment = Object.assign({}, item);
      this.modelPayment = Object.assign({}, item);
      this.dialogAddPayment = true;
    },
    deletePayment(item) {
      this.editedIndexPayment = this.model.payments.indexOf(item);
      this.currentPayment = Object.assign({}, item);
      if (this.sale) {
        this.activateConfirmDialog(
          "deletePaymentConfirm",
          item,
          `Seguro que desea eliminar el pago por valor de ${item.value}?`
        );
        return;
      }
      this.dialogDeletePayment = true;
    },
    deletePaymentConfirm() {
      if (this.sale) {
        this.$store.dispatch(
          "deleteSalePayment",
          this.currentPayment.payment_id
        );
      }
      this.model.payments.splice(this.editedIndexPayment, 1);
      this.closeDeletePayment();
    },
    closePayment() {
      this.dialogAddPayment = false;
      this.$nextTick(() => {
        this.currentPayment = null;
        this.modelPayment = {
          value: "",
          payment_method: "",
        };
        this.editedIndexPayment = -1;
        this.$refs.formPayment.resetValidation();
      });
    },
    closeDeletePayment() {
      this.dialogDeletePayment = false;
      this.$nextTick(() => {
        this.currentPayment = null;
        this.editedIndexPayment = -1;
      });
    },
    savePayment() {
      if (this.currentPayment) {
        Object.assign(
          this.model.payments[this.editedIndexPayment],
          this.modelPayment
        );
        if (this.sale) {
          this.$store.dispatch("updateSalePayment", {
            id: this.currentPayment.payment_id,
            form: this.modelPayment,
          });
        }
      } else {
        const paymentMethod = this.paymentMethods.find(
          (method) => method.value == this.modelPayment.payment_method
        );
        this.modelPayment.paymentMethodLan = paymentMethod.text;
        this.model.payments.push(this.modelPayment);
      }
      this.closePayment();
    },
    async saveSale() {
      if (this.model.payments.length == 0) {
        this.$store.commit(SET_ALERT, {
          message: "Debe agregar mínimo un pago",
          type: "error",
        });
        return;
      }

      await this.setNumber();      

      this.model.initial_value = await this.validatePayment();

      if (this.sale) {
        this.$store.dispatch("updateSale", {
          id: this.sale.id,
          form: this.model,
        });
      } else {
        this.$store.dispatch("createSale", this.model);
      }
    },
    validateValues() {
      var total = 0;
      this.model.dresses.forEach((element) => {        
        total += parseFloat(element.sale_value);
      });
      this.model.sale_value = total;
    },
    async validatePayment() {
      var total = 0;
      this.model.payments.forEach((element) => {
        total += parseFloat(element.value);
      });
      return total;
    },
    async setNumber() {
      if (typeof this.model.sale_value === "string")
        this.model.sale_value = this.model.sale_value.split(".").join("");

      this.model.dresses.forEach((element) => {
        if (typeof element.sale_value === "string")
          element.sale_value = element.sale_value.split(".").join("");
      });

      this.model.payments.forEach((element) => {
        if (typeof element.value === "string")
          element.value = element.value.split(".").join("");
      });

      this.validateValues();
    },
    setSale(sale) {
      this.sale = sale;
      this.currentClient = sale.client;
      this.model = {
        client_id: sale.client.id,
        sale_value: new Intl.NumberFormat("de-DE").format(
          parseInt(sale.sale_value)
        ),
        initial_value: new Intl.NumberFormat("de-DE").format(
          parseInt(sale.initial_value)
        ),
        lan: "es",
        employee_id: sale.employee.id,
        dresses: [],
        payments: [],
      };
      this.setClient();
      this.setDresses(sale.dresses);
      this.setPayments(sale.payments);
    },
    setDresses(dresses) {
      dresses.forEach((item) => {        
        this.model.dresses.push({
          id: item.id,
          code: item.code,
          sale_dress_id: item.pivot.id,
          category: item.category.id,
          dress: item,
          sale_value: new Intl.NumberFormat("de-DE").format(
            parseInt(item.pivot.sale_value)
          ),
        });
      });
    },
    setPayments(payments) {
      payments.forEach((item) => {
        const paymentMethod = this.paymentMethods.find(
          (method) => method.value == item.payment_method
        );

        this.model.payments.push({
          payment_id: item.id,
          value: new Intl.NumberFormat("de-DE").format(parseInt(item.value)),
          payment_method: item.payment_method,
          paymentMethodLan: paymentMethod.text,
        });
      });
    },
    activateConfirmDialog(callFunction, item, message) {
      this.confirmDialog.callFunction = callFunction;
      this.confirmDialog.message = message;
      this.confirmDialog.item = item;
      this.confirmDialog.active = true;
    },
    processConfirmDialog() {
      this[this.confirmDialog.callFunction]();
      this.deactivateConfirmDialog();
    },
    deactivateConfirmDialog() {
      this.confirmDialog.active = false;
      this.confirmDialog.callFunction = "";
      this.confirmDialog.message = "";
      this.confirmDialog.item = null;
    },
  },
};
</script>
